/** See `src/i18n/locales/en/manage.ts`. */
export const manage = {
  backToApp: 'Terug naar de app',
  sections: {
    companies: {
      label: 'Bedrijven',
      items: {
        companies: 'Bedrijven',
        pilots: 'Pilots',
      },
    },
    people: {
      label: 'Personen',
      items: {
        users: 'Alle gebruikers',
        linkIdentities: 'Identiteiten koppelen',
        admins: 'Beheerders',
      },
    },
    audit: {
      label: 'Audit',
      items: {
        audit: 'Audit-logboek',
      },
    },
    subscriptions: {
      label: 'Abonnementen',
      items: {
        config: 'Providerconfiguratie',
        products: 'Producten & providers',
        userLedger: 'Gebruikersoverzicht',
      },
    },
    system: {
      label: 'Systeem',
      items: {
        statistics: 'Statistiekenstatus & rebuild',
        requests: 'API-requests',
      },
    },
    support: {
      label: 'Support',
      items: {
        tickets: 'Tickets',
      },
    },
    overview: {
      label: 'Overzicht',
      items: {
        overview: "KPI's",
      },
    },
  },
  placeholders: {
    statistics: {
      title: 'Statistiekenstatus & rebuild',
      note: 'Statistiekenstatus en rebuild-bediening zijn een eigen plan — dit menu-item reserveert de plek, het scherm wordt in fase 1 niet gebouwd.',
    },
  },
  usersAll: {
    title: 'Alle gebruikers',
    linkIdentities: 'Identiteiten koppelen',
    empty: 'Er bestaan nog geen identiteiten.',
    name: 'Naam',
    email: 'E-mail',
    language: 'Taal',
    login: 'Inloggen',
    yes: 'ja',
    no: 'nee',
    view: 'Bekijken',
    rowsLabel: 'de gebruikers',
  },
  linkIdentities: {
    title: 'Dubbele identiteiten koppelen',
    lead: 'De alias blijft bestaan, maar verwijst naar de primaire identiteit. Tenzij je platformbeheerder bent, moet een van de twee loginloos zijn en wordt de identiteit met login de primaire — de server controleert dit, wat je hier ook kiest.',
    candidatesLabel: 'de personen die je beheert',
    needTwo: 'Je hebt minstens twee personen binnen je scope nodig om te koppelen.',
    aliasLabel: 'Alias (deze identiteit wordt de verwijzing)',
    primaryLabel: 'Primair (de identiteit die blijft bestaan)',
    choose: 'Kies…',
    hasLogin: '(heeft login)',
    noLogin: '(geen login)',
    link: 'Koppelen',
    cancel: 'Annuleren',
  },
  erase: {
    completedTitle: 'Verwijdering voltooid',
    completedText:
      'De identiteit is verwijderd. Het auditlogboek wordt gepseudonimiseerd, niet verwijderd; gekoppelde identiteiten blijven bestaan met een teruggezette verwijzing.',
    departmentsWithoutAdmin: 'Afdelingen zonder beheerder achtergebleven: {{names}}',
    measurementsNotDeleted:
      'Metingen in de ingest-service zijn NIET verwijderd — die mogelijkheid bestaat daar nog niet. Volg dit buiten het dashboard op.',
    backToUsers: 'Terug naar gebruikers',
    title: 'Deze persoon verwijderen',
    lead: 'Dit verwijdert onherroepelijk de identiteit {{userId}}: de gebruikersrij, lidmaatschappen, toestemmingen en rechten. Gekoppelde identiteiten blijven bestaan; door Gengee aangeleverde data blijft staan; het auditlogboek wordt gepseudonimiseerd. Typ {{confirmWord}} ter bevestiging.',
    confirmWord: 'ERASE',
    confirmationLabel: 'Bevestiging',
    erasePermanently: 'Definitief verwijderen',
    cancel: 'Annuleren',
  },
  requests: {
    title: 'API-requests',
    lead: 'De gelogde requests van de ingest-API voor een bron, meest recente eerst, optioneel ingeperkt tot een tijdvenster.',
    filterSource: 'Filteren op bron',
    sourcePlaceholder: 'bron-id',
    filterFrom: 'Van',
    filterTo: 'Tot',
    filter: 'Filteren',
    enterSourceHint: 'Voer een bron-id in om het requestlog te laden.',
    empty: 'Geen requests gelogd voor deze bron en dit venster.',
    when: 'Wanneer',
    method: 'Methode',
    path: 'Pad',
    status: 'Status',
    rowsLabel: 'de requests',
  },
} as const;
